<template>

  <div v-if="esGinecologia">
    <h4 class="text-center">Antecedentes Ginecologicos</h4>
    <div class="row align-items-center mt-3">

      <div 
        v-for="(opcion, index) in opciones" 
        :key="index" 
        :class="opcion.tipo === 'date' ? 'col-12' : 'col-6'"
      >
        <div
          v-if="opcion.tipo === 'select'"
          class="row mb-1 d-flex align-items-center"
        >
          <label :for="opcion.variable" class="col-7">
            {{ opcion.label }}:
          </label>

          <b-form-select
            v-model="dataAntecedentes[opcion.variable]"
            :options="opcion.options"
            class="col-5"
            :id="opcion.variable"
          />
        </div>

        <div 
          v-else-if="opcion.tipo !== 'date'" 
          class="row mb-1 d-flex align-items-center"
        >
          <label :for="opcion.variable" class="col-7">
            {{ opcion.label }}:
          </label>

          <b-form-input 
            v-model="dataAntecedentes[opcion.variable]" 
            type="text" 
            class="col-5" 
            :id="opcion.variable"
            :maxlength="opcion.tipo === 'number' ? 2 : null"
            @keypress="opcion.tipo === 'number' ? onlyNumbers($event) : null" 
          />

        </div>

        <div 
          v-if="opcion.tipo === 'date'" 
          class="row my-1 d-flex align-items-center"
        >
          <label :for="opcion.variable" class="col-4">
            {{ opcion.label }}:
          </label>

          <b-form-input 
            class="col-7" 
            v-if="opcion.tipo === 'date'" 
            v-model="dataAntecedentes[opcion.variable]"
            placeholder="descripcion" 
          />

        </div>
      </div>
    </div>


    <div class="row">

      <label 
        for="" 
        class="col-12"
      >Analisis:</label>

      <b-form-textarea 
        v-model="dataAntecedentes.analisis" 
        class="col-11 mx-1" 
      />
    </div>
  </div>
</template>

<script>
import { onlyNumbers } from "@/shared/helpers";
import { loadRespaldo, saveRespaldo } from '@/views/atencionCita/helpers';
import { ginecologiaService } from "@/views/atencionCita/services";
import { mapState } from "vuex";

export default {

  name: "AntecedentesGinecologicos",

  created() {
    this.loadData();
  },

  data() {
    return {

      onlyNumbers,
      tokenAtencion: null,
      entroUnaVez: false,

      dataAntecedentes: {
        menarquia: "",
        menopausia: "",
        ciclos: "",
        inicioSexual: "",
        gestas: "",
        partos: "",
        abortos: "",
        cesareas: "",
        hijosVivos: "",
        planificacionFamiliar: "",
        terapiaHormonal: "",
        ultimaMenstruacion: "",
        ultimoParto: "",
        citologiaCervical: "",
        colposcopia: "",
        mamografia: "",
        antigenoProstatico: "",
        ecoProstatico: "",
        analisis: "",
      },


      opciones: [
        {
          label: "Edad Menarquia",
          variable: "menarquia",
          tipo: "number"
        },
        {
          label: "Edad Menopausia",
          variable: "menopausia",
          tipo: "number"
        },
        {
          label: "Ciclos",
          variable: "ciclos",
          tipo: "select",
          options: [
            { value: "1", text: "Regular" },
            { value: "2", text: "Irregular" },
          ],
        },
        {
          label: "Edad inicio vida sexual",
          variable: "inicioSexual",
          tipo: "number"
        },
        {
          label: "Número de gestas",
          variable: "gestas",
          tipo: "number"
        },
        {
          label: "Número de partos",
          variable: "partos",
          tipo: "number"
        },
        {
          label: "Número de abortos",
          variable: "abortos",
          tipo: "number"
        },
        {
          label: "Número de cesáreas",
          variable: "cesareas",
          tipo: "number"
        },
        {
          label: "Número de hijos vivos",
          variable: "hijosVivos",
          tipo: "number"
        },

        {
          label: "Metodo de planificacion familiar",
          variable: "planificacionFamiliar",
          tipo: "text"
        },

        {
          label: "Terapia hormonal",
          variable: "terapiaHormonal",
          tipo: "text"
        },

        {
          label: "Fecha última menstruación",
          variable: "ultimaMenstruacion",
          tipo: "date"
        },
        {
          label: "Fecha último parto",
          variable: "ultimoParto",
          tipo: "date"
        },
        {
          label: "Fecha última citologia cervical",
          variable: "citologiaCervical",
          tipo: "date"
        },
        {
          label: "Fecha última colposcopia",
          variable: "colposcopia",
          tipo: "date"
        },
        {
          label: "Fecha última mamografia",
          variable: "mamografia",
          tipo: "date"
        },

        // {
        //   label: "Fecha ultimo antigeno prostático",
        //   variable: "antigenoProstatico",
        //   tipo: "date"
        // },

        // {
        //   label: "Fecha ultimo eco prostático",
        //   variable: "ecoProstatico",
        //   tipo: "date"
        // }
      ],


    }
  },



  methods: {
    normalizeCiclosValue(value) {
      if (value === null || value === undefined || value === "") return "";

      const normalizedValue = String(value).trim().toLowerCase();
      const normalizedMap = {
        "1": "1",
        "2": "2",
        regular: "1",
        irregular: "2",
      };

      return normalizedMap[normalizedValue] || "";
    },

    getCiclosLabel(value) {
      return value === "1" ? "Regular" : value === "2" ? "Irregular" : value;
    },

    normalizeDataAntecedentes(data = {}) {
      return {
        ...this.dataAntecedentes,
        ...data,
        ciclos: this.normalizeCiclosValue(data?.ciclos),
      };
    },

    async loadData() {
      this.idCita = this.$route.params.id;
      this.tokenAtencion = this.$route.params.token;
      this.identificadorAtencion = this.idCita ? this.idCita : this.tokenAtencion;

      if (this.idCita) {
        const dataLS = loadRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos');
        if (!dataLS) return;
        this.dataAntecedentes = this.normalizeDataAntecedentes(dataLS);
      }

      if (this.tokenAtencion) {
        const responseGineco = await ginecologiaService.getAntecedentesByAtencion(this.tokenAtencion);
        if (!responseGineco) return;

        const respaldoEdit = {
          tokenAntecedentes: responseGineco.token,
          items: this.normalizeDataAntecedentes(responseGineco.dataItems)
        };

        saveRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos', respaldoEdit);
        this.dataAntecedentes = this.normalizeDataAntecedentes(responseGineco.dataItems);
      }
    },


    getSummaryText() {

      const textArray = [];

      this.opciones.forEach(opcion => {
        const value = this.dataAntecedentes[opcion.variable];
        if (!value) return;
        const displayValue = opcion.variable === "ciclos"
          ? this.getCiclosLabel(value)
          : value;
        textArray.push(`${opcion.label}: ${displayValue}`);
      });

      textArray.unshift("ANTECEDENTES GINECOLOGICOS: ");

      const textFinish = {
        html: textArray.join("<br>"),
        text: textArray.join("\n")
      };

      this.$emit("input", textFinish);
    }
  },


  computed: {

    ...mapState({
      stDataDoctor: state => state.atencionCita.dataCita?.doctor,
      stDataSemiologia: state => state.atencionCita.semiologias?.semActual
    }),

    esGinecologia() {
      return this.stDataDoctor?.especialidad?.codEsp === '0000000148';
    },

  },



  watch: {
    stDataSemiologia: {
      async handler(newValue) {

        if (!this.entroUnaVez) {
          if (newValue.tipo === 'gineco') {
            this.dataAntecedentes = this.normalizeDataAntecedentes(newValue.data)
            this.entroUnaVez = true
          }
        }
      }
    },

    dataAntecedentes: {
      deep: true,
      handler(newValue) {
        if (this.idCita) {
          const allEmpty = Object.values(newValue).every(value => !value);
          const valueToSave = allEmpty ? null : newValue;
          saveRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos', valueToSave);
        }

        this.getSummaryText();

        const info_data = {
          tipo: 'gineco',
          data: newValue
        }

        this.$store.commit("setSemActual", info_data);

        if (this.tokenAtencion) {
          const respaldo = loadRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos');
          if (!respaldo) return;

          const respaldoEdit = {
            ...respaldo,
            items: newValue
          };

          saveRespaldo(this.identificadorAtencion, 'antecedentesGinecologicos', respaldoEdit);
        }

      }
    }
  },



}
</script>
